import { Link } from "react-router-dom";
import Iconify from "../../../../layouts/components/iconify/iconify";

export const renderEditGridAction = (rowData, col, rowIndex, allowEditGrid, onRowEditSave, isRowEditable, onRowEditCancel, editGridSettings, onRowDataDelete) => {

    const isEditingRow = allowEditGrid && isRowEditable;

    const handleDelete = (rowIndex) => {
        if (onRowDataDelete) {
            onRowDataDelete(rowIndex);
        }
    }

    const handleRowEditSave = (rowIndex, rowData) => {
        if (onRowEditSave) {
            onRowEditSave(rowIndex);
        }
    }

    const handleEditCancel = (rowIndex) => {
        if (onRowEditCancel) {
            onRowEditCancel(rowIndex);
        }
    }

    return (
        <div className="d-flex action-button">
            {isEditingRow && onRowEditSave && editGridSettings?.buttons?.save && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleRowEditSave(rowIndex, rowData);
                    }}
                    className="mr-4 save"
                    title="SAVE"
                >
                    <Iconify icon="ic:outline-check" />
                </Link>
            )}

            {/* Cancel Button */}
            {isEditingRow && onRowEditCancel && editGridSettings?.buttons?.cancel && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleEditCancel(rowIndex);
                    }}
                    className="mr-4 cancel"
                    title="CANCEL"
                >
                   <Iconify icon="gridicons:cross" />
                </Link>
            )}

            {isEditingRow && editGridSettings?.buttons?.delete && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleDelete(rowIndex);
                    }}
                    className="mr-4"
                    title="DELETE"
                >
                 <Iconify icon="mingcute:delete-2-line" />
                </Link>
            )}
        </div>
    );
};